import { createTermsTagsManager } from '../../utils/createTermsTagsManager';
import { HEATING_TYPES_MAP_VALUE_TO_LABEL } from './constants';

export const heatingTypeTagsManager = createTermsTagsManager({
  jsonQueryKey: 'heating_source_type',
  mapValueToLabel: HEATING_TYPES_MAP_VALUE_TO_LABEL,
  id: 'heatingType',
});
